import { useNavigate } from 'react-router';
import { PrimaryButton } from './PrimaryButton';
import { SecondaryButton } from './SecondaryButton';

interface ProActionButtonsProps {
  onCancel?: () => void;
  onSave?: () => void;
  saveLabel?: string;
  className?: string;
}

export function ProActionButtons({
  onCancel,
  onSave,
  saveLabel = 'Save',
  className = ''
}: ProActionButtonsProps) {
  const navigate = useNavigate();

  return (
    <div className={`flex items-center justify-between w-full ${className}`}>
      <SecondaryButton
        onClick={onCancel || (() => navigate(-1))}
        className="!px-12 !h-[56px] !bg-[#f5f5f5] !border-none !text-[#908e8e] !rounded-[12px] !font-bold min-w-[160px]"
      >
        Cancel
      </SecondaryButton>
      <PrimaryButton
        onClick={onSave || (() => navigate(-1))}
        className="!px-12 !h-[56px] !bg-[#8e2a2f] !rounded-[12px] !font-bold min-w-[160px]"
      >
        {saveLabel}
      </PrimaryButton>
    </div>
  );
}
